// A GAVETA DA FICHA DO CONTATO É DESTE APARELHO (06/10/2026).
//
// "Ficha do contato aberta" é preferência da pessoa, gravada no servidor e
// sincronizada entre aparelhos (`is_contact_sidebar_open`). No computador ela
// é uma COLUNA ao lado da conversa — deixar aberta faz sentido. Abaixo de
// 1280px ela vira GAVETA por cima da conversa, e herdar a preferência do
// computador fazia o celular abrir TODA conversa coberta pela ficha (medido
// em 390px: a primeira coisa na tela era "Info · CRM · Notas", não a
// mensagem).
//
// Agora a gaveta só aparece quando foi aberta AQUI, nesta sessão — pelo
// nome do contato, pelo botão de informações ou pelo "Histórico". A
// preferência do computador continua intacta.
import { ref } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

export const gavetaAbertaAqui = ref(false);

export const usePainelDoContato = () => {
  const { updateUISettings } = useUISettings();

  const abrirPainelDoContato = () => {
    gavetaAbertaAqui.value = true;
    updateUISettings({ is_contact_sidebar_open: true });
  };

  return { gavetaAbertaAqui, abrirPainelDoContato };
};
